import { Component,
  OnInit,
  ViewChild,
  ElementRef,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { DatePipe, Location, formatDate } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';

import { ClaimService } from 'src/app/_service/claim.service';
import { VesselService } from 'src/app/_service/vessel.service';
import { UserService } from 'src/app/_service/user.service';
import { CompanyService } from 'src/app/_service/company.service';
import { EquipmentService } from 'src/app/_service/equipment.service';
import { AttachmentService } from 'src/app/_service/attachment.service';
import { CommunicationService } from 'src/app/_service/communication.service';
import { editClaimForm } from 'src/app/_model/claim';
import { OriginalFormComponent } from '../../claim-center/original-form/original-form.component';
import { postUserData } from 'src/app/_model/user_data';
import { getCompanyData, postCompanyData } from 'src/app/_model/company';
import { getVesselData, postVesselData } from 'src/app/_model/vessel';
import { postEmailData, postCommentData } from 'src/app/_model/communication';
import { AssigneeUtil } from 'src/app/_common/common.assignee';
import { CompanyEditComponent } from '../../companies/company-edit/company-edit.component';
import { getApplications, getAddons } from 'src/app/_model/vessel';
import { TranslateService } from '@ngx-translate/core';
import {
  combineLatest,
  firstValueFrom,
  startWith,
  Observable,
  map,
  forkJoin,
  Subscription,
  of,
  EMPTY
} from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { STATUS, CLAIM_TAG_OPTIONS, MAX_ATTACHMENT_BYTES } from 'src/app/_model/string_literal';
import { DomSanitizer } from '@angular/platform-browser';
import { FormControl } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { trigger, state, style, transition, animate } from '@angular/animations';

import { environment } from "src/environments/environment";

import { Router } from '@angular/router';
import { AuthService } from 'src/app/_service/auth.service';

import * as routing from '../../../_model/routing';
import { ConfirmDialogComponent } from '../../claim-center/claim-edit/confirm-dialog/confirm-dialog.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-inquiry-edit',
  templateUrl: './inquiry-edit.component.html',
  styleUrls: ['./inquiry-edit.component.css'],
  providers: [DatePipe],
  animations: [
    trigger('fadeInOut', [
      state('visible', style({ opacity: 1 })),
      state('hidden', style({ opacity: 0 })),
      transition('visible => hidden', [animate('500ms ease-out')]),
      transition('hidden => visible', [animate('500ms ease-in')])
    ])
  ],
})
export class InquiryEditComponent implements OnInit{
  form = new editClaimForm;
  editClaimForm = this.form.defaultForm;
  isEditMode = false;
  selectedClaim: any;
  updatedClaim: any;
  claimVessel: any;
  updatedClaimVessel: any;
  claimCompany: any;
  claimSubmitter: any;
  claimEquipModel: any;
  claimEquip: any;
  claimVesselEquip: any;
  updatedClaimVesselEquip: any;
  updatedClaimEquipModel: any = undefined;
  updatedClaimEquip: any = undefined;
  updatedClaimProdModel: any = undefined;
  updatedClaimProd: any = undefined;
  updatedClaimProdCategory: any = undefined;
  claimProd: any;
  claimProdModel: any;
  claimProdCategory: any;
  claimEquipManufacturer: any;
  vesselOwner: any;
  vesselBuilder: any;
  vesselManager: any;
  assignee: any;
  currAssignee: any;
  selectedPriority: any;
  currPriority: any;
  selectedMark: any;
  currMark: any;
  isSelectingAssignee = false;
  agentList: any[] = [];
  JRCS_ID = "09f08b32-1cbe-4b69-bf51-f3b8a742bc02";
  currStatus: any;
  userData!: postUserData;
  companyData!: postCompanyData;
  vesselData!: postVesselData;
  applicationList: getApplications[] = [];
  addonList: getAddons[] = [];
  vesselApps: any = [];
  vesselAppsTree: any = {};
  files: any = [];
  updatedFiles: any = [];
  vesselList: any = [];
  vesselEquipList: any[] = [];
  userList: any[] = [];
  incidentDateLocalString: string = "";
  expectedPortCallLocalString: string = "";
  isConfidential = 0;
  emailThreads: any[] = [];
  emailFiles: any = {};
  commentFiles: any = {};
  claimCompanyMembers: any[] = [];
  selectedRecipients: any = {};
  selectedCommentRecipients: any[] = [];
  message: string = '';
  showNewEmailBtn = true;
  createNewEmailThread = false;
  commentTxt: string = '';
  allComments: any[] = [];
  jrcsUserList: any[] = [];
  isInquiryNotFound = false;
  submitterCompany: any;
  vesselEquipRequest?: Subscription;
  relatedClaim: any = null;
  relatedClaimState: 'loading' | 'ready' | 'error' = 'loading';

  recipientCtrl: { [threadId: string]: FormControl } = {};
  commentRecipientCtrl: FormControl = new FormControl('');
  filteredRecipients: { [threadId: string]: Observable<any[]> } = {};
  filteredCommentRecipients: Observable<any[]> = of([]);
  @ViewChildren('recipientInput') recipientInputs!: QueryList<any>;

  @ViewChild('emailFileInput') emailFileInputRef!: ElementRef<HTMLInputElement>;
  @ViewChild('commentFileInput') commentFileInputRef!: ElementRef<HTMLInputElement>;

  @ViewChild('chipRef', { read: ElementRef}) 
  set chipRef(ref: ElementRef | undefined){
    if (!ref) {
      return;
    }
    
    const hostEl = ref.nativeElement;
    const inputEl = hostEl?.querySelector('input');

    if (inputEl && !inputEl.dataset['pasteListenerAttached']) {
      inputEl.addEventListener('paste', (event: ClipboardEvent) => {
        event.preventDefault();
        event.stopImmediatePropagation();

        const pastedText = event.clipboardData?.getData('text') || '';
        const cursorPos = inputEl.selectionStart || 0;
        const currentValue = inputEl.value;
        const newValue =
          currentValue.slice(0, cursorPos) + pastedText + currentValue.slice(cursorPos);
        
        inputEl.value = newValue;
        inputEl.dispatchEvent(new Event('input', {bubbles: true}));
      }, true);

      inputEl.dataset['pasteListenerAttached'] = 'true';
    }

    if (hostEl && !hostEl.dataset['tokenClickListenerAttached']) {
      hostEl.addEventListener('click', (event: MouseEvent) => {
        const target = event.target as HTMLElement;
        if (
          (target.closest('.p-chips-token')) && !target.closest('.p-chips-token-icon')
        ) {
          event.preventDefault()
          event.stopImmediatePropagation();
        }
      }, true);
    }
    hostEl.dataset['tokenClickListenerAttached'] = 'true';

  }

  loadRelatedClaim(groupId: string) {
    this.claimService.getRecordByGroupId(groupId, 'claim').subscribe({
        next: (value: any) => {
          this.relatedClaim = value[0];
        },
        error: (error) => {
          console.error('Error fetching related claim:', error);
        },
      });
  }

  tags: string[] = [];
  isAddingTag = false;

  tagsBeforeEdit: string[] = [];

  isTagsExpanded = true;

  selectedVessel!: any;

  newEmailFiles: any = [];
  newCommentFiles: any = [];

  tagOptions = CLAIM_TAG_OPTIONS;

  tagQuery = "";
  showTagSuggestions = false;

  tagInputElement: HTMLInputElement | null = null;

  csNumberDate = '';
  csNumberSequence = '';

  priority = [
    {
      "id": 1,
      "name": "high"
    },
    {
      "id": 2,
      "name": "medium"
    },
    {
      "id": 3,
      "name": "low"
    },
  ];

  mark = [
    {
      "id": 4,
      "name": "advice"
    },
    {
      "id": 0,
      "name": "guarantee"
    },
  ];

  statusList = [
    {
      "id": 0,
      "name": "new",
    },
    {
      "id": 0,
      "name": "open",
    },
    {
      "id": 10,
      "name": "resolved",
    },
    {
      "id": 6,
      "name": "closed",
    },
  ];

  constructor(
    private datePipe: DatePipe,
    private claimService: ClaimService,
    private vesselService: VesselService,
    private userService: UserService,
    private companyService: CompanyService,
    private equipmentService: EquipmentService,
    private attachmentService: AttachmentService,
    private communicationService: CommunicationService,
    private location: Location,
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private translate: TranslateService,
    private sanitizer: DomSanitizer,
    private iconRegistry: MatIconRegistry,
    public auth: AuthService,
  ) {
    this.iconRegistry.addSvgIcon(
      'send',
      sanitizer.bypassSecurityTrustResourceUrl('assets/send-outlined.svg')
    );

    this.iconRegistry.addSvgIcon(
      'attachment',
      sanitizer.bypassSecurityTrustResourceUrl('assets/attachment-outlined.svg')
    );
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const readableId = params.get('readableId');

      if (!readableId) {
        return;
      }

      const selectedClaim = this.claimService.selectedClaim;

      const selectedClaimMatchesUrl =
        selectedClaim &&
        [selectedClaim?.id, selectedClaim?.readableId]
          .filter(id => id != null)
          .some(id => String(id) === String(readableId));

      if (selectedClaimMatchesUrl) {
        this.isInquiryNotFound = false;
        this.initializeClaim();
      } else {
        this.getCurrClaimData(readableId);
      }
    });
  }

  initRecipient(threadId: string) {
    this.recipientCtrl[threadId] = new FormControl('');

    this.filteredRecipients[threadId] = this.recipientCtrl[threadId].valueChanges.pipe(
      startWith(''),
      map(value => typeof value === 'string' ? value : value?.name || ''),
      map(value => this.filterRecipients(value))
    );

    this.filteredCommentRecipients = this.commentRecipientCtrl.valueChanges.pipe(
      startWith(''),
      map(value => typeof value === 'string' ? value : value?.name || ''),
      map(value => this.filterCommentRecipients(value))
    );
  }

  originalFormSnapshot: any = null;

  captureOriginalForm(recordType: 'claim' | 'inquiry'): void {
    this.originalFormSnapshot = structuredClone({
      recordType,
      claim: this.selectedClaim,
      vessel: this.claimVessel,
      equipment: this.claimVesselEquip,
      product: this.claimProd,
      category: this.claimProdCategory,
      shipyard: this.vesselBuilder,
      owner: this.vesselOwner,
      company: this.claimCompany,
      files: this.files || [],
    });
  }

  openOriginalForm(): void {
    this.dialog.open(OriginalFormComponent, {
      width: '800px',
      maxWidth: '94vw',
      maxHeight: '90vh',
      autoFocus: false,
      data: {
        ...this.originalFormSnapshot,
        openVessel: (vessel: any) => this.goVesselDetails(vessel),
        openCompany: (company: any) => this.goCompanyDetails(company),
        downloadFile: (id: string, name: string, type: string) =>
          this.downloadFile(id, name, type),
      },
    });
  }

  createEmailThread() {
    this.createNewEmailThread = true;
    this.showNewEmailBtn = false;
    if (!this.recipientCtrl['new']) {
      this.initRecipient('new');
    }
    if (!this.selectedRecipients['new']) {
      this.selectedRecipients['new'] = [];
    }
  }

  onConfidentialChange(event: any) {
    this.isConfidential = event.target.checked ? 1 : 0;
  }

  initializeClaim() {
    this.selectedClaim = this.claimService.selectedClaim;
    if (!this.selectedClaim) {
      this.getCurrClaimData();
      return;
    }

    if (!this.selectedClaim.inquiryClaimGroupId) {
      this.relatedClaimState = 'ready';
    } else {
      this.loadRelatedClaim(this.selectedClaim.inquiryClaimGroupId);
    }

    this.isEditMode = false;
    this.files = [];
    this.emailThreads = [];
    this.newEmailFiles = [];
    this.newCommentFiles = [];
    this.isConfidential = this.selectedClaim?.isConfidential ?? 0;
    this.updatedClaim = structuredClone(this.selectedClaim);

    const match = (this.updatedClaim?.csNumber ?? '')
      .trim()
      .match(/^CS(\d{6})-(\d+)$/i);

    this.csNumberDate = match?.[1] ?? '';
    this.csNumberSequence = match?.[2] ?? '';

    if (this.selectedClaim?.isRead === 0) this.markAsRead();

    combineLatest([
      this.vesselService.vesselList$,
      this.userService.userList$,
      this.companyService.companyList$
    ]).subscribe({
      next: ([vessels, users, companies]) => {
        this.vesselList = vessels || [];
        this.claimVessel = vessels?.find((v: any) => v.id === this.selectedClaim?.vesselId);
        this.updatedClaimVessel = this.claimVessel;
        if (this.updatedClaimVessel) {
          this.equipmentService.getVesselEquipByVesselId(this.updatedClaimVessel?.id).subscribe({
            next: (value: any) => {
              this.vesselEquipList = value?.data || [];
              if (!this.vesselEquipList.some((e: any) => e.id === this.claimVesselEquip?.id)) {
                this.updatedClaimVesselEquip = undefined;
              }
            },
            error: () => {
              console.error('Failed fetching vessel equipment list.');
            },
          });
        }

        this.claimCompanyMembers = (users || []).filter((u: any) => u.company_id === this.updatedClaimVessel?.manager_id);
        this.getVesselApplications();

        this.userList = users || [];
        this.jrcsUserList = this.userList.filter((u: any) => u.company_id == this.JRCS_ID);
        this.claimSubmitter = (users || []).find((u: any) => u.id === this.selectedClaim?.submittedUserId);
        this.submitterCompany = (companies || []).find((c: any) => c.id === this.claimSubmitter?.company_id);
        this.assignee = (users || []).find((u: any) => u.id === this.selectedClaim?.assignee);
        this.currAssignee = (users || []).find((u: any) => u.id === this.selectedClaim?.assignee);
        this.agentList = (users || [])
          .filter((u: any) => u.company_id === this.JRCS_ID)
          .map((u: any) => ({ ...u, displayLabel: AssigneeUtil.getLabel(u) }));

        this.claimCompany = (companies || []).find((c: any) => c.id === this.updatedClaimVessel?.manager_id);
        this.vesselOwner = this.updatedClaimVessel?.vesselOwner;
        this.vesselBuilder = (companies || []).find((c: any) => c.id === this.updatedClaimVessel?.builder_id);
        this.vesselManager = (companies || []).find((c: any) => c.id === this.updatedClaimVessel?.manager_id);

        if (this.selectedClaim?.equipmentId) {
          this.getClaimVesselEquip(this.selectedClaim?.equipmentId);
        }
      },
      error: (err) => {
        console.error('Failed loading claim related data.', err);
      }
    });

    this.currStatus = this.getCurrStatus(this.selectedClaim);
    this.currPriority = this.priority.find((p: any) => p.id === this.selectedClaim?.priority);
    this.selectedPriority = this.priority.find((p: any) => p.id === this.selectedClaim?.priority);

    this.incidentDateLocalString = this.toDateTimeLocalString(this.selectedClaim?.incidentDate);
    this.expectedPortCallLocalString = this.toDateTimeLocalString(this.selectedClaim?.expectedPortCall);

    this.currMark = this.mark.find((p: any) => p.id === this.selectedClaim?.mark);
    this.selectedMark = this.mark.find((p: any) => p.id === this.selectedClaim?.mark);

    this.tags = this.normalizeTags(this.selectedClaim?.tags);
    this.tagsBeforeEdit = [...this.tags];

    this.getApplicationList();
    this.getAddons();
    this.getEmailThreads();
    this.getComments();

    const attachmentIds = this.selectedClaim?.attachmentIds || [];
    attachmentIds.forEach((id: any) => {
      this.attachmentService.getAttachment(id).subscribe({
        next: (fileInfo: any) => {
          this.files.push(fileInfo);
          this.files.sort((a: any, b: any) => a.filename.localeCompare(b.filename, ['ja', 'en']));
        },
        error: (err) => {
          console.error('Failed loading attachment', err);
        }
      });
    });
  }

  getUserCompanyName(userId: any) {
    const user = this.userList.find(u => u.id === userId);
    const companyId = user?.company_id;
    return this.companyService.companyList.find(c => c.id === companyId)?.name || this.companyService.companyList.find(c => c.id === companyId)?.otherName || '';
  }

  getUserName(userId: string) {
    return this.userList.find(u => u.id === userId)?.name || "";
  }

  getEmailThreads() {
    this.emailThreads = [];
    const emailThreadIds = this.selectedClaim?.emailThreadIds;
    if (emailThreadIds?.length > 0) {
      emailThreadIds?.forEach((threadId: any) => {
        this.selectedRecipients[threadId] = [];
      });
      this.showNewEmailBtn = false;
      emailThreadIds.forEach((id: any) => this.initRecipient(id));
      forkJoin(emailThreadIds.map((id: any) => this.communicationService.getEmailThreadById(id)))
        .subscribe((results: any) => {
          results?.forEach((item: any) => {
            item?.data?.forEach((email: any) => {
              email.displayBody = email.body.replace(/<br\s*\/?>/gi, '\n');
            });
          });
          results?.map((item: any) => this.emailThreads.push(item?.data?.reverse()));
          this.getEmailFiles();
        });
    } else {
      this.initRecipient('new');
      this.selectedRecipients['new'] = [];
    }
  }

  getComments() {
    this.allComments = [];
    this.communicationService.getComments(this.selectedClaim?.id).subscribe({
      error: (err) => { console.error(this.translate.instant("fetchCommentErr")); },
      next: (item: any) => {
        item?.data.forEach((c: any) => {
          c.displayComment = c.comment.replace(/<br\s*\/?>/gi, '\n');
        });
        this.allComments.push(...item?.data?.reverse());
        this.getCommentFiles();
      }
    });
  }

  refreshEmail(threadId: any) {
    this.selectedRecipients[threadId] = [];
    this.message = '';
    this.getEmailThreads();
  }

  refreshComments() {
    this.selectedCommentRecipients = [];
    this.getComments();
    this.commentTxt = '';
  }

  async sendComment() {
    const attachmentIds = this.newCommentFiles.map((f: any) => f.id);
    this.commentTxt = this.commentTxt.replace(/\n/g, '<br>');

    if (attachmentIds.includes(undefined)) {
      window.alert(this.translate.instant("fileUploadingErr"));
      return;
    }

    if (this.selectedCommentRecipients.length > 0) {
      const commentNotificationEmailContent = `
        ${this.auth.userName}さんがクレーム『${this.selectedClaim?.title}』にコメントしました。<br><br>
        ${this.commentTxt}<br><br>
        下記URLの「社内コミュニケーション」タブよりご確認ください。<br><br>
        ${window.location.href}
      `
      const emailData: postEmailData = {
        recipient_ids: this.selectedCommentRecipients.map((u: any) => u.id),
        subject: '【クレーム】新しいコメントを受信しました',
        body: commentNotificationEmailContent,
        attachment_ids: attachmentIds,
      };
      this.communicationService.createNewEmail(emailData).subscribe({
        error: (err) => { window.alert(this.translate.instant("sendEmailErr")); },
        next: (value: any) => {
          window.alert(this.translate.instant("commentEmailSent"));
        }
      });
    }

    const commentData: postCommentData = {
      comment: this.commentTxt,
      attachmentIds: attachmentIds,
    };

    this.communicationService.commentOnEmail(this.selectedClaim?.id, commentData).subscribe({
      error: (err) => { window.alert(this.translate.instant("addCommentErr")); },
      next: () => {
        this.refreshComments();
        this.newCommentFiles = [];
      }
    });
  }

  async sendReply(threadId: any, parentId: any) {
    const attachmentIds = this.newEmailFiles.map((f: any) => f.id);
    this.message = this.message.replace(/\n/g, '<br>');

    if (attachmentIds.includes(undefined)) {
      window.alert(this.translate.instant("fileUploadingErr"));
      return;
    }

    const emailData: postEmailData = {
      recipient_ids: this.selectedRecipients[threadId].map((u: any) => u.id),
      subject: 'JRCS Updates',
      body: this.message,
      attachment_ids: attachmentIds,
    };

    if (!this.createNewEmailThread && parentId) {
      this.communicationService.replyToExistingEmail(parentId, emailData).subscribe({
        error: (err) => { window.alert(this.translate.instant("sendEmailErr")); },
        next: () => {
          this.refreshEmail(threadId);
          this.createNewEmailThread = false;
          this.newEmailFiles = [];
        }
      });
    } else {
      this.communicationService.createNewEmail(emailData).subscribe({
        error: (err) => { window.alert(this.translate.instant("sendEmailErr")); },
        next: (value: any) => {
          this.addThreadId(value?.data?.thread_id);
          this.newEmailFiles = [];
        }
      });
    }
  }

  addThreadId(threadId: any) {
    this.claimService.updateClaim({ emailThreadIds: [threadId], id: this.selectedClaim?.id, }).subscribe({
      error: (err) => { window.alert(this.translate.instant("err")); },
      next: () => {
        this.getCurrClaimData();
        this.createNewEmailThread = false;
        this.message = '';
      },
    });
  }

  removeRecipient(user: any, threadId: any,) {
    this.selectedRecipients[threadId] = this.selectedRecipients[threadId].filter((u: any) => u !== user);
  }

  removeCommentRecipient(user: any) {
    this.selectedCommentRecipients = this.selectedCommentRecipients.filter((u: any) => u !== user);
  }

  filterRecipients(value: any) {
    const search = typeof value === 'string'
    ? value.toLowerCase()
    : value?.name?.toLowerCase() || '';

    return this.userList.filter(user =>
      user.name.toLowerCase().includes(search) ||
      user.email.toLowerCase().includes(search)
    );
  }

  filterCommentRecipients(value: any) {
    const search = typeof value === 'string'
    ? value.toLowerCase()
    : value?.name?.toLowerCase() || '';

    return this.jrcsUserList.filter(user =>
      user.name.toLowerCase().includes(search) ||
      user.email.toLowerCase().includes(search)
    );
  }

  selectUser(event: any, threadId: any, input: any) {
    const user = event.option.value;

    if (!this.selectedRecipients[threadId].find((u: any) => u.email === user.email)) {
      this.selectedRecipients[threadId].push(user);
    }
    input.value = '';

    this.recipientCtrl[threadId].reset();
    event.option.deselect();
  }

  selectUserForComment(event: any, input: any) {
    const user = event.option.value;

    if (!this.selectedCommentRecipients.find((u: any) => u.email === user.email)) {
      this.selectedCommentRecipients.push(user);
    }
    input.value = '';

    this.commentRecipientCtrl.reset();
    event.option.deselect();
  }

  getCommentFiles() {
    this.commentFiles = {};

    this.allComments.forEach((comment: any) => {
      comment.attachmentIds?.forEach((id: any) => {
        this.attachmentService.getAttachment(id).subscribe((fileInfo: any) => {
          if (!this.commentFiles[comment.id]) {
            this.commentFiles[comment.id] = [];
          }
          this.getPreviewUrl(fileInfo);
          this.commentFiles[comment.id].push(fileInfo);
          this.commentFiles[comment.id].sort((a: any, b: any) => a.filename.localeCompare(b.filename, ['ja', 'en']));
        });
      });
    });
  }

  getEmailFiles() {
    this.emailFiles = {};
    this.emailThreads.forEach((thread: any) => {
      thread.forEach((email: any) => {
        email.attachment_ids?.forEach((id: any) => {
          this.attachmentService.getAttachment(id).subscribe((fileInfo: any) => {
            if (!this.emailFiles[email.id]) {
              this.emailFiles[email.id] = [];
            }
            this.getPreviewUrl(fileInfo);
            this.emailFiles[email.id].push(fileInfo);
            this.emailFiles[email.id].sort((a: any, b: any) => a.filename.localeCompare(b.filename, ['ja', 'en']));
          });
        });
      });
    });
  }

  formatDateLocal(utc: any) {
    const currLang = this.translate.currentLang;
    if (currLang === 'en') {
      return formatDate(utc, 'dd MMM. yyyy HH:mm', 'en-US')
    } else {
      return formatDate(utc, 'yyyy年MM月dd日 HH:mm', 'en-US')
    }
  }

  getPreviewUrl(file: any) {
    this.attachmentService.getAttachmentContents(file.id)
      .subscribe((response: any) => {

        const blob = new Blob([response], { type: file.filetype });
        const url = URL.createObjectURL(blob);

        if (file.filetype === 'application/pdf') {
          file.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        } else {
          file.previewUrl = url;
        }
      });
  }

  getCurrClaimData(currClaimReadableId?: string | null) {
    if (!currClaimReadableId) {
      currClaimReadableId = window.location.pathname.split('/').at(-1);
    }

    if (!currClaimReadableId) {
      return;
    }

    this.isInquiryNotFound = false;

    this.claimService
      .getClaimByReadableId(currClaimReadableId, "inquiry")
      .subscribe({
        next: (value: any) => {
          this.claimService.selectedClaim = value;
          if (value?.recordType !== "inquiry") {
            this.isInquiryNotFound = true;
          }
          const navigationIndex =
            this.claimService.claimNavigationIndex;

          if (navigationIndex >= 0) {
            this.claimService.claimNavigationClaims[navigationIndex] = value;
          }
          this.initializeClaim();
        },
        error: (error) => {
          console.error('Error fetching claim:', error);

          if (error.status === 404) {
            this.isInquiryNotFound = true;
          }

          this.claimService.selectedClaim = null;
          this.selectedClaim = null;
        },
      });
  }
  getCurrShipyard(id: any) {
    if (!id) {
      return ""
    }
    const shipyard = this.companyService.companyList.find((c: any) => c.id === id);
    return shipyard?.name || shipyard?.otherName || "";
  }

  get canGoPrevious() {
    return this.claimService.claimNavigationIndex > 0;
  }

  get canGoNext() {
    return this.claimService.claimNavigationIndex >= 0 && this.claimService.claimNavigationIndex < this.claimService.claimNavigationClaims.length - 1;
  }

  goToPreviousClaim() {
    const previousClaim = this.claimService.getClaimForNavigation('previous');
    if (!previousClaim) {
      return;
    }

    this.switchClaim(previousClaim);
  }

  goToNextClaim() {
    const nextClaim = this.claimService.getClaimForNavigation('next');
    if (!nextClaim) {
      return;
    }

    this.switchClaim(nextClaim);
  }

  private switchClaim(claim: any) {
    if (!claim) {
      return;
    }

    const readableId = claim?.readableId || claim?.id;

    if (!readableId) {
      return;
    }

    this.claimService.selectedClaim = claim;

    this.router.navigate([
      '/dashboard/inquiry-center/inquiry-edit',
      readableId
    ]);
  }

  markAsRead() {
    const data = {
      id: this.selectedClaim?.id,
      isRead: 1,
      recordType: 'inquiry'
    }
    this.selectedClaim.isRead = 1;
    this.claimService.updateClaim(data).subscribe({
      error: err => console.error('Failed to update isRead', err)
    });
  }

  onFileListChange(newData: any) {
    this.updatedFiles = newData;
  }

  getCurrStatus(claim: any) {
    if (claim.status === STATUS.NEW) {
      if (claim.assignee === null)
        return this.statusList[0];
      return this.statusList[1]
    }
    if (claim.status === STATUS.CLOSED)
      return this.statusList[3];
    if (claim.status === STATUS.RESOLVED)
      return this.statusList[2];
    return;
  }

  resetUpdatedEquipmentChain() {
    this.updatedClaimEquipModel = undefined;
    this.updatedClaimEquip = undefined;
    this.updatedClaimProdModel = undefined;
    this.updatedClaimProd = undefined;
    this.updatedClaimProdCategory = undefined;
  }

  unwrapFirst(response: any) {
    return response?.data?.[0] ?? null;
  }

  getClaimVesselEquip(id: string) {
    if (!id) {
      this.claimVesselEquip = undefined;
      this.updatedClaimVesselEquip = undefined;
      this.claimEquipModel = undefined;
      this.claimEquip = undefined;
      this.claimProd = undefined;
      this.claimProdCategory = undefined;
      this.claimEquipManufacturer = undefined;
      return;
    }
    this.equipmentService.getVesselEquipById(id).subscribe({
      next: (value: any) => {
        this.claimVesselEquip = value?.data?.[0];
        this.updatedClaimVesselEquip = this.claimVesselEquip;
        this.getClaimEquipModel(this.claimVesselEquip?.equipmentModelId);
        this.onVesselSelected();
      },
      error: () => {
        console.error("Failed to get claim vessel equipment.");
      },
    });
  }

  onClickCancelEdit() {
    this.tags = [...this.tagsBeforeEdit];
    this.isEditMode = false;
    this.updatedClaimVesselEquip = this.claimVesselEquip;
    this.updatedClaimVessel = this.claimVessel;
    this.updatedClaim = structuredClone(this.selectedClaim);

    const match = (this.updatedClaim?.csNumber ?? '')
      .trim()
      .match(/^CS(\d{6})-(\d+)$/i);

    this.csNumberDate = match?.[1] ?? '';
    this.csNumberSequence = match?.[2] ?? '';

    this.incidentDateLocalString = this.toDateTimeLocalString(this.selectedClaim?.incidentDate);
    this.expectedPortCallLocalString = this.toDateTimeLocalString(this.selectedClaim?.expectedPortCall);
  }

  onVesselSelected() {
    if (this.updatedClaimVessel) {
      this.claimCompanyMembers = this.userList.filter(u => u.company_id === this.updatedClaimVessel?.manager_id);
      this.equipmentService.getVesselEquipByVesselId(this.updatedClaimVessel?.id).subscribe({
        next: (value: any) => {
          this.vesselEquipList = value?.data;
          if (!this.vesselEquipList.some((e: any) => e.id === this.claimVesselEquip?.id)) {
            this.updatedClaimVesselEquip = undefined;
          }
        },
        error: (err) => {
          console.error("Failed fetching vessel equipment list.")
        },
      });
    } else {
      this.claimCompanyMembers = [];
      this.updatedClaimVesselEquip = undefined;
      this.vesselEquipList = [];
    }
  }

  onVesselEquipSelected() {
    this.vesselEquipRequest?.unsubscribe();
    this.resetUpdatedEquipmentChain();

    const equipmentModelId =
      this.updatedClaimVesselEquip?.equipmentModelId;

    if (!equipmentModelId) {
      return;
    }

    this.vesselEquipRequest = this.equipmentService
      .getEquipModelById(equipmentModelId)
      .pipe(
        map(response => this.unwrapFirst(response)),

        tap(equipmentModel => {
          this.updatedClaimEquipModel = equipmentModel;
        }),

        switchMap(equipmentModel => {
          const equipmentId = equipmentModel?.equipmentId;

          return equipmentId
            ? this.equipmentService.getEquipById(equipmentId).pipe(
                map(response => this.unwrapFirst(response))
              )
            : of(null);
        }),

        tap(equipment => {
          this.updatedClaimEquip = equipment;
        }),

        switchMap(equipment => {
          const productModelId = equipment?.productModelId;

          return productModelId
            ? this.equipmentService.getProductModelById(productModelId).pipe(
                map(response => this.unwrapFirst(response))
              )
            : of(null);
        }),

        tap(productModel => {
          this.updatedClaimProdModel = productModel;
        }),

        switchMap(productModel => {
          const productId = productModel?.productId;

          return productId
            ? this.equipmentService.getProductById(productId).pipe(
                map(response => this.unwrapFirst(response))
              )
            : of(null);
        }),

        tap(product => {
          this.updatedClaimProd = product;
        }),

        switchMap(product => {
          const categoryId = product?.categoryId;

          return categoryId
            ? this.equipmentService.getCategoryById(categoryId).pipe(
                map(response => this.unwrapFirst(response))
              )
            : of(null);
        }),

        tap(category => {
          this.updatedClaimProdCategory = category;
        }),

        catchError(error => {
          console.error('Failed to load equipment chain', error);
          this.resetUpdatedEquipmentChain();
          return EMPTY;
        })
      )
      .subscribe();
  }

  toDateTimeLocalString(isoString: string) {
    if (!isoString) return "";

    const date = new Date(isoString);
    if (Number.isNaN(date.getTime())) return "";

    const jstOffsetMs = 9 * 60 * 60 * 1000;

    return new Date(date.getTime() + jstOffsetMs)
      .toISOString()
      .slice(0, 16);
  }

  toUtcISOStringFromJst(value: string): string | null {
    if (!value?.trim()) return null;

    const date = new Date(`${value}+09:00`);

    return Number.isNaN(date.getTime())
      ? null
      : date.toISOString();
  }

  getClaimEquipModel(id: string) {
    if (!id) {
      this.claimEquipModel = undefined;
      this.claimEquipManufacturer = undefined;
      this.claimEquip = undefined;
      this.claimProd = undefined;
      this.claimProdCategory = undefined;
      return;
    }

    this.equipmentService.getEquipModelById(id).subscribe({
      next: (value: any) => {
        this.claimEquipModel = value?.data?.[0];
        this.getClaimEquip(this.claimEquipModel?.equipmentId)
      },
      error: () => {
        console.error("Failed to get claim equipment model.");
      },
    });
  }

  getClaimEquip(id: string) {
    if (!id) {
      this.claimEquipManufacturer = undefined;
      this.claimEquip = undefined;
      this.claimProd = undefined;
      this.claimProdCategory = undefined;
      return;
    }

    this.equipmentService.getEquipById(id).subscribe({
      next: (value: any) => {
        this.claimEquip = value?.data?.[0];
        this.getEquipManufacturer(this.claimEquip?.manufacturerId)
        this.getEquipProdModel(this.claimEquip?.productModelId);
      },
      error: () => {
        console.error("Failed to get claim equipment.");
      },
    });
  }

  getEquipManufacturer(id: string) {
    if (!id) {
      this.claimEquipManufacturer = undefined;
      return;
    }

    this.equipmentService.getManufacturerById(id).subscribe({
      next: (value: any) => {
        this.claimEquipManufacturer = value?.data?.[0];
      },
      error: () => {
        console.error("Failed to get claim equipment manufacturer.");
      },
    });
  }

  getEquipCategory(id: string) {
    if (!id) {
      this.claimProdCategory = undefined;
      return;
    }

    this.equipmentService.getCategoryById(id).subscribe({
      next: (value: any) => {
        this.claimProdCategory = value?.data?.[0];
        this.updatedClaimProdCategory = this.claimProdCategory;
      },
      error: () => {
        console.error("Failed to get claim equipment category.");
      },
    });
  }

  getEquipProdModel(id: string) {
    if (!id) {
      this.claimProdModel = undefined;
      this.claimProd = undefined;
      this.claimProdCategory = undefined;
      return;
    }

    this.equipmentService.getProductModelById(id).subscribe({
      next: (value: any) => {
        this.claimProdModel = value?.data?.[0];
        this.getEquipProd(this.claimProdModel?.productId);
      },
      error: () => {
        console.error("Failed to get claim product.");
      },
    });
  }

  getEquipProd(id: string) {
    if (!id) {
      this.claimProd = undefined;
      this.claimProdCategory = undefined;
      return;
    }

    this.equipmentService.getProductById(id).subscribe({
      next: (value: any) => {
        this.claimProd = value?.data?.[0];
        this.updatedClaimProd = this.claimProd;
        this.getEquipCategory(this.claimProd?.categoryId);
      },
      error: () => {
        console.error("Failed to get claim product.");
      },
    });
  }

  formatDate(dateStr: string) {
    if (this.translate.currentLang === 'jp') {
      return this.datePipe.transform(dateStr, 'yyyy/MM/dd HH:mm');
    }
    return this.datePipe.transform(dateStr, 'dd MMM. yyyy HH:mm') || '';
  }

  formatDateForIncidentorNextCall(dateStr: string) {
    if (this.translate.currentLang === 'jp') {
      return this.datePipe.transform(dateStr, 'yyyy/MM/dd HH:mm:ss');
    }
    return this.datePipe.transform(dateStr, 'dd MMM. yyyy HH:mm') || '';
  }

  getJSTTime() {
    const now = new Date();

    const jstDate = new Date(
      now.toLocaleString("en-US", { timeZone: "Asia/Tokyo" })
    );

    const pad = (n: any) => String(n).padStart(2, "0");

    const year = jstDate.getFullYear();
    const month = pad(jstDate.getMonth() + 1);
    const day = pad(jstDate.getDate());
    const hours = pad(jstDate.getHours());
    const minutes = pad(jstDate.getMinutes());

    return {
      usFormat: `${month}/${day}/${year} ${hours}:${minutes}`,
      jpFormat: `${year}年${month}月${day}日 ${hours}:${minutes}`,
    };
  }

  async updateClaim() {
    if (this.auth.isYakuin) {
      window.alert(this.translate.instant("noPermission"));
      return;
    }

    const csDate = (this.csNumberDate ?? '').trim();
    const csSequence = (this.csNumberSequence ?? '').trim();

    if (
      (csDate || csSequence) &&
      (!/^\d{6}$/.test(csDate) || !/^[1-9]\d*$/.test(csSequence))
    ) {
      window.alert(
        '日付6桁（YYMMDD）と先頭に0を付けない正の整数を入力してください。 / Enter a six-digit date (YYMMDD) and a positive integer without leading zeros.'
      );
      return;
    }

    this.editClaimForm.patchValue(this.updatedClaim);
    const claimUpdateNotificationSubject = `【更新通知】お問合せ『${this.updatedClaim?.title}』更新のお知らせ`;
    const claimUpdateNotificationContent = `
      JRCSへのお問合せ『${this.updatedClaim?.title}』は ${this.getJSTTime().jpFormat}（JST）に更新されました。<br>
      Inquiry to JRCS titled ${this.updatedClaim?.title} was updated at ${this.getJSTTime().usFormat} JST.<br><br>
      下記URLよりご確認ください。<br>
      Please refer to the following URL.<br><br>
      ${environment?.assistURL}/dashboard/support/${this.updatedClaim.id}
    `;
    const claimUpdateEmail: postEmailData = {
      recipient_ids: this.claimCompanyMembers?.map(m => m?.id),
      subject: claimUpdateNotificationSubject,
      body: claimUpdateNotificationContent,
      attachment_ids: undefined,
    };

    this.editClaimForm.get("incidentDate")?.setValue(
      this.toUtcISOStringFromJst(this.incidentDateLocalString)
    );

    this.editClaimForm.get("expectedPortCall")?.setValue(
      this.toUtcISOStringFromJst(this.expectedPortCallLocalString)
    );

    const attachmentArray = this.updatedFiles.map((f: any) => f.id || "").filter((id: any) => id?.trim());
    const vesselManagerId = this.updatedClaimVessel?.manager_id;

    for (const file of this.files) {
      try {
        await firstValueFrom(
          this.attachmentService.updateFile({ id: file.id, companyId: vesselManagerId })
        );
      } catch (err) {
        window.alert(
          this.translate.instant('updateFileErr', {
            fileName: file.name
          })
        );
        return;
      }
    }

    this.editClaimForm.get('attachmentIds')?.setValue(attachmentArray);

    this.editClaimForm.get('assignee')?.setValue(this.assignee?.id);
    this.editClaimForm.get('priority')?.setValue(this.selectedPriority?.id);
    this.editClaimForm.get('mark')?.setValue(this.selectedMark?.id);
    this.editClaimForm.get('status')?.setValue(this.currStatus.id);
    this.editClaimForm.get('isConfidential')?.setValue(this.isConfidential);
    this.editClaimForm.get('tags')?.setValue([...this.tags]);

    if (this.updatedClaimVessel) {
      this.editClaimForm.get('vesselId')?.setValue(this.updatedClaimVessel.id);
    } else {
      this.editClaimForm.get('vesselId')?.setValue(null);
    }

    if (this.updatedClaimVesselEquip) {
      this.editClaimForm.get('equipmentId')?.setValue(this.updatedClaimVesselEquip.id);
    } else {
      this.editClaimForm.get('equipmentId')?.setValue(null);
    }

    const payload = { ...this.editClaimForm.value };

    delete payload.csNumberSuffix;

    if (csDate && csSequence) {
      payload.csNumberSuffix = `${csDate}-${csSequence}`;
    }

    this.claimService.updateClaim(payload).subscribe({
      error: (err) => {
        const message =
          (err.status === 400 || err.status === 409) &&
          typeof err.error?.message === 'string'
            ? err.error.message
            : this.translate.instant("err");

        window.alert(message);
      },
      complete: () => {
        window.alert(this.translate.instant("updated"));
        // remove claim update email for now
        // if (this.updatedClaimVessel) {
        //   this.communicationService.createNewEmail(claimUpdateEmail).subscribe({
        //     error: (err) => { window.alert(this.translate.instant("sendEmailErr")); },
        //   });
        // }
        this.getCurrClaimData();
      },
    });
  }

  onCancel() {
    this.location.back();
  }

  onDelete() {
    if (this.auth.isYakuin) {
      window.alert(this.translate.instant("noPermission"));
      return;
    }
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: this.translate.instant('inquiryDeleteTitle'),
        message: this.translate.instant('inquiryDeleteMsg'),
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.claimService.deleteClaim(this.selectedClaim?.id).subscribe({
          error: (err) => { window.alert(this.translate.instant("err")); },
          complete: () => {
            window.alert(this.translate.instant("deleted"));
            this.location.back();
          },
        });
      }
    });
  }

  onClickChangeAssignee() {
    this.isSelectingAssignee = true;
  }

  getAssigneeLabel(user: any): string {
    return AssigneeUtil.getLabel(user);
  }

  onClickClaimCenter() {
    this.router.navigate([routing.InquiryCenter]);
  }

  onAssigneeSelect() {
    this.isSelectingAssignee = false;
    if (this.assignee) {
      this.currStatus = this.statusList[1];
    } else {
      this.currStatus = this.statusList[0];
    }
  }

  onStatusSelect() {
    if (this.currStatus?.name === "New")
      this.assignee = undefined;
  }

  getStatusClass(status: string) {
    return "option-" + status.toLowerCase();
  }

  goRequesterDetails(rowData: any) {
    this.userService.selectedUserID = rowData.id;
    this.router.navigate([routing.UserPreview + "/" + this.userService.selectedUserID]);
  }

  formatRequesterTime(timestamp: string) {
    const date = new Date(timestamp);

    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');

    return `${year}.${month}.${day} ${hours}:${minutes} UTC`;
  }

  goCompanyDetails(selectedData: any) {
    if (this.auth.isYakuin) {
      window.alert(this.translate.instant("noPermission"));
      return;
    }
    this.addToCompanyData(selectedData);
  }

  addToCompanyData(data: getCompanyData) {
    this.companyData = {
      name: data.name,
      otherName: data.otherName,
      ceo: data.ceo,
      address: data.address,
      addressLineTwo: data.addressLineTwo,
      city: data.city,
      zipCode: data.zipCode,
      telephone: data.telephone,
      fax: data.fax,
      email: data.email,
      thumbnailExtension: data.thumbnailExtension,
      businessContents: data.businessContents,
      rank: data.rank,
      country:data.country,
      types: this.companyService.getCompanyType(data),
      typeOwner: data.typeOwner,
      typeManagement: data.typeManagement,
      typeBuilder: data.typeBuilder,
      typeManufacturer: data.typeManufacturer,
      typeMaintainer: data.typeMaintainer,
      typeExOwner: data.typeExOwner,
      typeExManagement: data.typeExManagement,
      isGlobalReadable: data.isGlobalReadable,
    };
    this.companyService.editCompanyFlag = true;
    this.companyService.editCompanyData = this.companyData;
    this.editCompanyData();
  }

  editCompanyData() {
    const dialogRef = this.dialog.open(CompanyEditComponent, { width:'744px', height: '90vh' });
  }

  goVesselDetails(selectedData: any) {
    if (this.auth.isYakuin) {
      window.alert(this.translate.instant("noPermission"));
      return;
    }
    this.vesselService.selectedVesselID = selectedData?.id;
    this.addToVesselData(selectedData);
  }
  addToVesselData(data: getVesselData) {
    this.vesselData={
      name: data.name,
      otherName: data.otherName,
      imo: data.imo,
      vesselNumber: data.vesselNumber,
      firstClass: data.firstClass,
      secondClass: data.secondClass,
      thumbnailExtension: data.thumbnailExtension,
      owner_id: data.owner_id,
      manager_id: data.manager_id,
      builder_id: data.builder_id,
      maintener_id: data.maintener_id,
      exowner_id: data.exowner_id,
      exmanager_id:data.exmanager_id,
      METype: data.METype,
      NoME: data.NoME,
      NoDG: data.NoDG,
      NoSG: data.NoSG,
      MEEngineType: data.MEEngineType,
      bore: data.bore,
      stroke: data.stroke,
      cylinder: data.cylinder,
      cycle: data.cycle,
      meMaxKw: data.meMaxKw,
      normalMeMaxKw: data.normalMeMaxKw,
      meMaxRpm: data.meMaxRpm,
      normalMeMaxRpm: data.normalMeMaxRpm,
      meMinRpm: data.meMinRpm,
      geMaxKw: data.geMaxKw,
      sgMaxKw: data.sgMaxKw,
      engineFoUnit: data.engineFoUnit,
      engineFoUnitFactor: data.engineFoUnitFactor,
      generatorFoUnit: data.generatorFoUnit,
      generatorFoUnitFactor: data.generatorFoUnitFactor,
      vesselType: data.vesselType,
      NoLeg: data.NoLeg,
      NoCrane: data.NoCrane,
      NoThruster: data.NoThruster,
      MEngine: data?.MEngine,
      exName: data.exName,
      mmsi: data.mmsi,
      officialNumber: data.officialNumber,
      signalLetters: data.signalLetters,
      flag: data.flag,
      portOfRegistry: data.portOfRegistry,
      builtPlace: data.builtPlace,
      structuralDesignType:data.structuralDesignType,
      purpose: data.purpose,
      operationalStatus: data.operationalStatus,
      NoCrewMembers: data.NoCrewMembers,
      notation: data.notation,
      steelCuttingDate: data.steelCuttingDate,
      keelLayingDate: data.keelLayingDate,
      launchDate: data.launchDate,
      deliveryDate: data.deliveryDate,
      meFuelConsumptionRate: data.meFuelConsumptionRate,
      geFuelConsumptionRate: data.geFuelConsumptionRate,
      NoRudders: data.NoRudders,
      rudderType: data.rudderType,
      propellerType: data.propellerType,
      bladeDiameter: data.bladeDiameter,
      NoBlades: data.NoBlades,
      minCPPAngle: data.minCPPAngle,
      maxCPPAngle:data.maxCPPAngle,
      NoTank: data.NoTank,
      totalLength: data.totalLength,
      waterlineLength: data.waterlineLength,
      LBP: data.LBP,
      width: data.width,
      draft: data.draft,
      mouldedDepth: data.mouldedDepth,
      netTonnage: data.netTonnage,
      grossTonnage: data.grossTonnage,
      deadweightTonnage: data.deadweightTonnage,
      // cargoCapacityUnit: data.cargoCapacityUnit,//need to remove
      // cargoCapacity: data.cargoCapacity,//need to remove
      passengerCapacity: data.passengerCapacity,
      // tankCapacity: data.tankCapacity,//need to remove
      bulbousBow: data.bulbousBow,
      meBuiltYear: data.meBuiltYear,
      L_w:data.L_w,
      C_B: data.C_B,
      eta_D: data.eta_D,
      maxSpeedKn: data.maxSpeedKn,
      trialSpeedList: data?.trialSpeedList,
      trialPowerList: data?.trialPowerList,
      hotelPower: data.hotelPower,
      shipType:data.shipType,
      builtYear:data?.builtYear,
      callsign:data.callsign,
      salesRepresentativeName:data.salesRepresentativeName,
      salesAddress:data.salesAddress,
      salesEmail:data.salesEmail,
      salesTelephone:data.salesTelephone,
      salesAgentName:data.salesAgentName,
      salesAgentAddress:data.salesAgentAddress,
      salesAgentEmail:data.salesAgentEmail,
      salesAgentTelephone:data.salesAgentTelephone,
      vesselWarrantyStartDate:data.vesselWarrantyStartDate,
      vesselWarrantyBaseExpDate:data.vesselWarrantyBaseExpDate,
      vesselWarrantyExtExpDate:data.vesselWarrantyExtExpDate,
      vesselWarrantyExpDate:data.vesselWarrantyExpDate,
      cargoBaleM3: data.cargoBaleM3,
      cargoGrainM3: data.cargoGrainM3,
      cargoLiquidM3: data.cargoLiquidM3,
      cargoNoBulldozer: data.cargoNoBulldozer,
      cargoNoCar: data.cargoNoCar,
      cargoNoChassis: data.cargoNoChassis,
      cargoNoFeu: data.cargoNoFeu,
      cargoNoForklift: data.cargoNoForklift,
      cargoNoTeu: data.cargoNoTeu,
      cargoNoTrailer: data.cargoNoTrailer,
      cargoNoTrainCar: data.cargoNoTrainCar,
      cargoNoTruck: data.cargoNoTruck,
      cargoOtherCapacity: data.cargoOtherCapacity,
      cargoOtherUnit: data.cargoOtherUnit,
      cargoRefM3: data.cargoRefM3,
      tankCapacityFoM3: data.tankCapacityFoM3,
      tankCapacityFwM3: data.tankCapacityFwM3,
      tankCapacityWbM3: data.tankCapacityWbM3,
      isEdge: data.isEdge,
    };
    this.vesselService.editVesselFlag = true;
    this.vesselService.editVesselData = this.vesselData;
    this.editVesselData();
  }

  editVesselData() {
    this.router.navigate([routing.VesselEdit + "/" + this.vesselService.selectedVesselID]);
  }

  getApplicationList() {
    this.vesselService.getApplications().subscribe({
      next: (value) => {
        value.forEach(element => {this.applicationList.push(element)});
      },
      error: (error) => {
        console.error(error);
      },
    })
  }

  getVesselApplications() {
    if (!this.updatedClaimVessel) return;
    this.vesselService.selectedVesselID = this.updatedClaimVessel?.id;
    this.vesselService.getVesselApplicationList(this.vesselService.selectedVesselID).subscribe({
      next: (value: any) => {
        value.forEach((a: any) => {
          this.vesselApps.push(a);
        });
      },
      error: (error) => {
        console.error(error);
      },
    })
  }

  getAppName(id: string) {
    return this.applicationList.find(app => app.id === id)?.name;
  }

  getAddonName(id: string) {
    return this.addonList.find(addon => addon.id === id)?.name;
  }

  getAddons() {
    this.vesselService.getAddon().subscribe({
      next: (value: any) => {
        value.forEach((element: any) => {this.addonList.push(element)});
      },
      error: (error) => {
        console.error(error);
      },
    })
  }

  formatFileSize(bytes: number) {
    if (bytes < 1024) return `${bytes} B`;
    else if (bytes < 1024*1024) return `${(bytes / 1024).toFixed(1)} KB`;
    else return `${(bytes / (1024*1024)).toFixed(1)} MB`;
  }

  downloadFile(id: string, name: string, type: string) {
    this.attachmentService.getAttachmentContents(id).subscribe((response: any) => {
      const blob = new Blob([response], { type: type });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      window.URL.revokeObjectURL(url);
    });
  }

  onFileSelected(event: Event, targetFiles: any[], fileInputRef: ElementRef<HTMLInputElement>) {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const target = event.target as HTMLInputElement;
    if (target.files)
      this.addFiles(target.files, targetFiles, fileInputRef);
  }

  triggerFileInput(elementId: any) {
    const fileInput = document.getElementById(elementId) as HTMLInputElement;
    fileInput.click();
  }

  addFiles(files: FileList, targetFiles: any[], fileInputRef: ElementRef<HTMLInputElement>) {
    const filesArray = Array.from(files);

    const totalSize = targetFiles.reduce((sum: any, file: any) => sum + file.size, 0) + filesArray.reduce((sum, file) => sum + file.size, 0);
    if (totalSize > MAX_ATTACHMENT_BYTES) {
      window.alert(this.translate.instant("totalFileSizeErr"));
      return;
    }

    filesArray.forEach(file => {
      const existingFile = targetFiles.find((f: any) => f.name === file.name);
      if (existingFile?.status === "done") {
        window.alert(
          this.translate.instant("fileAlreadyUploaded", {
            fileName: file.name
          })
        );
      } else {
        if (existingFile) {
          const index = targetFiles.indexOf(existingFile);
          if (index !== -1) {
            targetFiles.splice(index, 1);
          }
        }
        const newFile = {
          name: file.name,
          size: file.size,
          status: "uploading",
          showUploaded: false,
          id: undefined,
          subscription: null as Subscription | null,
        }
        targetFiles.push(newFile);

        const formData = new FormData();
        formData.append("attach", file, file.name);
        if (this.updatedClaimVessel)
          formData.append("companyId", this.updatedClaimVessel?.manager_id);

        newFile.subscription = this.attachmentService.uploadFile(formData)
          .subscribe({
            next: (response: any) => {
              newFile.id = response.id,
              newFile.status = "done";
              newFile.showUploaded = true;

              setTimeout(() => {
                newFile.showUploaded = false;
              }, 1500);
            },
            error: (err) => {
              newFile.status = "error";
              window.alert(
                this.translate.instant("fileUploadFailed", {
                  fileName: file.name
                })
              );
            },
          });
      }
    });

    fileInputRef.nativeElement.value = '';
  }

  removeFile(file: any, targetFiles: any[]) {
    file?.subscription?.unsubscribe();
    const index = targetFiles.findIndex((f: any) => f.name === file.name);
    if (index !== -1) {
      targetFiles.splice(index, 1);
    }
  }

  onClickEdit() {
    this.captureOriginalForm('inquiry');
    this.isEditMode = true;

    this.tagsBeforeEdit = [...this.tags];
  }

  onClickConvert() {
    const id = this.selectedClaim.id;

    this.claimService.convertToClaim(id).subscribe({
      error: (err) => {
        const message =
          (err.status === 400 || err.status === 409) &&
          typeof err.error?.message === 'string'
            ? err.error.message
            : this.translate.instant("err");

        window.alert(message);
      },
      next: (data: any) => {
        if (data?.created) {
          window.alert(this.translate.instant("convertedToClaim"));
        } else {
          window.alert(this.translate.instant("claimExists"));
        }
        this.getCurrClaimData(this.selectedClaim.readableId);
      },
    });
    
  }

  toggleTags(): void {
    this.isTagsExpanded = !this.isTagsExpanded;
  }

  normalizeTags(value: unknown): string[] {
    const tags = Array.isArray(value)
      ? value
      : typeof value === "string"
        ? value.split(",")
        : [];

    const existingTags = new Set<string>();

    return tags
      .filter((tag): tag is string => typeof tag === "string")
      .map((tag) => tag.trim())
      .filter((tag) => {
        const normalizedTag = tag.toLowerCase();

        if (!tag || existingTags.has(normalizedTag)) {
          return false;
        }

        existingTags.add(normalizedTag);
        return true;
      });
  }

  onTagsChange(): void {
    this.tags = this.normalizeTags(this.tags);
  }

  get filteredTagOptions() {
    const query = this.tagQuery.toLowerCase();

    const selectedTags = new Set(
      (this.tags || []).map(tag => tag.toLowerCase())
    );

    return this.tagOptions.filter(option => {
      const normalizedOption = option.toLowerCase();

      return (
        !selectedTags.has(normalizedOption) &&
        normalizedOption.includes(query)
      );
    });
  }

  openTagSuggestions(event: Event) {
    const input = event.target as HTMLInputElement;

    this.tagInputElement = input;
    this.tagQuery = input.value.trim();
    this.showTagSuggestions = true;
  }

  onTagInput(event: Event) {
    const input = event.target as HTMLInputElement;

    if (input.tagName !== "INPUT") {
      return;
    }

    this.tagInputElement = input;
    this.tagQuery = input.value.trim();
    this.showTagSuggestions = true;
  }

  onTagAdded() {
    this.onTagsChange();
    this.tagQuery = "";
    this.showTagSuggestions = true;
  }

  selectTagSuggestion(option: string, event: MouseEvent) {
    event.preventDefault();

    const alreadySelected = (this.tags || []).some(
      tag => tag.toLowerCase() === option.toLowerCase()
    );

    if (!alreadySelected) {
      this.tags = [...(this.tags || []), option];
    }

    this.tagQuery = "";
    this.showTagSuggestions = true;

    if (this.tagInputElement) {
      this.tagInputElement.value = "";
      this.tagInputElement.dispatchEvent(
        new Event("input", { bubbles: true })
      );
      this.tagInputElement.focus();
    }
  }

  closeTagSuggestions() {
    this.tagQuery = "";
    this.showTagSuggestions = false;
  }

  get statusOptions() {
    const hasAssignee = this.selectedClaim?.assignee != null;
    if (hasAssignee) {
      return this.statusList.filter(
        status => status.name !== 'new'
      );
    }
    return this.statusList.filter(
      status => status.name !== 'open'
    );
  }

  tagCopiedText = '';

  onChipMouseUp(event: MouseEvent) {
    const selection = window.getSelection();
    const text = selection ? selection.toString() : '';

    if (text) {
      this.tagCopiedText = text;
      navigator.clipboard.writeText(text).catch(() => {});
    }
  }
}
